export enum ImmobilizationType {
  REST_AREA = "Rest area",
  ACTIVE_LANE = "Active lane",
  EMERGENCY_LANE = "Emergency lane",
}
